import { Pipe, PipeTransform } from '@angular/core';
import { MaintenanceTimerDetailDto } from '@artemis-software/wr-api';

@Pipe({
  standalone: false,
  name: 'maintenanceTimerType',
})
export class MaintenanceTimerTypePipe implements PipeTransform {

  transform(type: MaintenanceTimerDetailDto.TypeEnum): string {
    switch (type) {
      case MaintenanceTimerDetailDto.TypeEnum.Maintenance:
        return 'Wartung';
      case MaintenanceTimerDetailDto.TypeEnum.Inspection:
        return 'Inspektion';
      case MaintenanceTimerDetailDto.TypeEnum.SelfInspection:
        return 'Eigen-/Betriebskontrolle';
      case MaintenanceTimerDetailDto.TypeEnum.Warranty:
        return 'Gewährleistung';
      default:
        return '';
    }
  }

}
